import { formatTextBlobToList } from '../Helpers/formatText';

export const AdPartner = ({ adIndex, partnerData }) => {
    const { id, image, title, description, buttonLabel = 'Get My Quote' } = partnerData;

    const redirectUrl = `/ads/${id}?page=${window?.Laravel?.page?.id}`;
    const formattedDescription = formatTextBlobToList(description);

    const bestMatches = [
        { ticks: 3, text: 'Top Choice' },
        { ticks: 2, text: 'Fast Quote' },
        { ticks: 1, text: 'Quick & Easy' },
    ];

    const bestMatch = bestMatches[adIndex];

    return (
        <a href={redirectUrl} target="_blank" rel="noopener noreferrer" data-testid="ad-partner">
            <div className="partner-container">
                <div className="partner-container__logo">
                    <img src={image} alt={`${title} Logo`} />
                </div>

                <div className={`partner-container__description${bestMatch ? ' partner-container__matches' : ''}`}>
                    <div className="partner-container__description-text">
                        <h3 dangerouslySetInnerHTML={{ __html: title }} />
                        <ul>{formattedDescription}</ul>
                    </div>

                    {bestMatch && (
                        <div className="partner-container__matches-content">
                            <div className="partner-container__matches-ticks">
                                {Array.from({ length: bestMatch.ticks }).map((_, i) => (
                                    <span key={i} className="icon-tick" aria-hidden="true" />
                                ))}
                            </div>
                            <div className="partner-container__matches-text">{bestMatch.text}</div>
                        </div>
                    )}
                </div>

                <div className="partner-container__cta">
                    <button className="cta-btn">{buttonLabel}</button>
                </div>
            </div>
        </a>
    );
};
